<template>
  <div
    class="flex xs4 align-center justify-content-center"
    style="display: flex; max-width: 100%; height: 100%; align-items: center; justify-content: center;"
  >
    <v-dialog v-model="dialog" persistent max-width="800px">
      <template v-slot:activator="{ on, attrs }">
        <v-flex v-bind="attrs" v-on="on" class="notification-title">
          お知らせ一覧
        </v-flex>
      </template>
      <v-card class="wrapper">
        <v-layout class="header" wrap>
          <v-flex xs12 class="title">
            <h1>お知らせ一覧</h1>
          </v-flex>
          <v-flex xs12 mt-4>
            <v-layout class="notification-buttons">
              <NotificationButtons
                :unreadRequestNotificationCount="unreadRequestNotificationCount"
                :unreadSystemNotificationCount="unreadSystemNotificationCount"
                :color="color"
                :disabled="allListLoading"
                :isHideRevenue="isHideRevenue"
                @onClickSystem="onClickSystem"
                @onClickRequest="onClickRequest"
              />
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout class="body">
          <NotificationList
            :notificationList="notificationList"
            :loading="allListLoading"
            style="width: 100%"
          />
        </v-layout>
        <v-layout class="footer">
          <v-flex>
            <NotificationReadAllButton
              :unreadNotificationList="unreadNotificationList"
              :loading="unReadListLoading"
              @fetchUnreadNotificationsCount="fetchUnreadNotificationsCount"
            />
          </v-flex>
          <v-flex>
            <v-pagination
              v-if="!allListLoading"
              v-model="pageNo"
              :length="notificationListCount"
              :total-visible="7"
              @input="fetchNotificationListByPageNo"
            />
          </v-flex>
          <v-flex ma-2>
            <v-btn @click="dialog = false" class="close-button">
              閉じる
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import NotificationList from './NotificationList'
import NotificationReadAllButton from './NotificationReadAllButton'
import NotificationButtons from './NotificationButtons'
import { NotificationRepository } from '@/models/Notification'
import { NotificationType } from '@/models/Notification/Constants'

const defaultColor = '#DDDDDD'

export default {
  name: 'NotificationInformation',
  components: {
    NotificationList,
    NotificationButtons,
    NotificationReadAllButton,
  },
  props: {
    unreadRequestNotificationCount: {
      type: Number,
      default: 0,
    },
    unreadSystemNotificationCount: {
      type: Number,
      default: 0,
    },
    isHideRevenue: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      isSystem: false,
      isRequest: true,
      dialog: false,
      pageNo: 1,
      color: {
        system: defaultColor,
        request: 'primary',
      },
      notificationList: [],
      notificationListCount: 0,
      unreadNotificationList: [],
      allListLoading: false,
      unReadListLoading: false,
    }
  },
  computed: {
    notificationType() {
      if (this.isSystem) return NotificationType.system
      if (this.isRequest) return NotificationType.request
      return ''
    },
  },
  watch: {
    async isSystem(val) {
      if (val) {
        this.color.system = 'primary'
        await this.fetchNotificationList()
      } else {
        this.color.system = defaultColor
      }
      this.pageNo = 1
    },
    async isRequest(val) {
      if (val) {
        this.color.request = 'primary'
        await this.fetchNotificationList()
      } else {
        this.color.request = defaultColor
      }
      this.pageNo = 1
    },
    async dialog(val) {
      if (val) {
        await this.fetchNotificationList()
      }
    },
  },
  methods: {
    onClickSystem(...args) {
      const [isSystemClicked, isRequestClicked] = args
      this.isSystem = isSystemClicked
      this.isRequest = isRequestClicked
    },
    onClickRequest(...args) {
      const [isRequestClicked, isSystemClicked] = args
      this.isSystem = isSystemClicked
      this.isRequest = isRequestClicked
    },
    async fetchNotificationList() {
      await this.fetchNotificationListByPageNo()
      if (
        (this.isSystem && this.unreadSystemNotificationCount > 0) ||
        (this.isRequest && this.unreadRequestNotificationCount > 0)
      ) {
        await this.fetchUnreadNotificationList()
      }
    },
    async fetchNotificationListByPageNo() {
      this.allListLoading = true
      const notificationList = await NotificationRepository.getNotificationsByPageNo(
        this.notificationType,
        this.pageNo,
      )
      this.notificationList = notificationList.items
      this.notificationListCount = Math.ceil(notificationList.count / 20)
      this.allListLoading = false
    },
    async fetchUnreadNotificationList() {
      this.unReadListLoading = true
      this.unreadNotificationList = await NotificationRepository.getAllNotificationsByIsRead(
        this.notificationType,
        false,
      )
      this.unReadListLoading = false
    },
    fetchUnreadNotificationsCount() {
      this.fetchNotificationListByPageNo()
      this.$emit('fetchUnreadNotificationsCount')
    },
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  height: 80vh;
  overflow: hidden;
}
.notification-title {
  color: blue;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.title {
  margin-left: 34%;
  margin-top: 30px;
}
.notification-buttons {
  margin-left: 60%;
}
.header {
  top: 0;
  height: 120px;
  width: 100%;
}
.body {
  margin-top: 50px;
  width: 100%;
  height: 65%;
  overflow-y: auto;
  overflow-x: hidden;
}
.footer {
  bottom: 0;
  height: 50px;
  width: 100%;
  background-color: white;
}
.close-button {
  display: block;
  margin: 0 0 0 auto;
}
</style>
